import React, { useEffect, useState } from "react";
import { Table, TableRow } from "../../../components/Table";
import { Button } from "reactstrap";
import { MdLogout } from "react-icons/md";
import DeleteModal from "../../../components/Custom/Modals/DeleteModal/DeleteModal";
import { useDispatch } from "react-redux";
import { responseToaster } from "../../../helperFunctions";
import {
  approvedSubUser,
  logoutSubUser,
  setUsers,
  useUsers,
} from "../../../redux/slices/usersSlice";
import ToggleSwitch from "../../../components/Custom/Forms/ToggleSwitch/ToggleSwitch";
import { useRole } from "../../../redux/slices/authSlice";

const LoginUsers = (props) => {
  const { items, onGet } = props;
  const dispatch = useDispatch();
  const role_manager = useRole("Role Manager");

  const [filterColumns, setFilterColumns] = useState([]);
  const [deleteId, setDeleteId] = useState("");
  const [approvedLoader, setApprovedLoader] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const data = useUsers();

  const updateApprovUser = async (payload) => {
    try {
      setApprovedLoader(payload?.id);

      const res = await dispatch(approvedSubUser(payload)).unwrap();

      const index = data?.data?.findIndex?.(
        (item) => item?.id === payload?.parentId
      );

      if (index > -1 && res?.status) {
        const newData = [...data?.data];

        const user = { ...newData[index] };

        const updatedLoginUsers = user?.login_users?.map?.((loginUser) => {
          if (loginUser?.id === payload?.id) {
            return { ...loginUser, is_approve: payload?.isApprove };
          }
          return loginUser;
        });

        user.login_users = updatedLoginUsers;

        newData[index] = user;
        dispatch(setUsers({ ...data, data: newData }));
      }

      responseToaster(res);
      setApprovedLoader(false);
    } catch (err) {
      console.log("err", err);
      setApprovedLoader(false);
    }
  };

  const columns = [
    {
      title: "ID",
      name: "id",
    },
    {
      title: "USER ID",
      name: "user_id",
    },
    {
      title: "device details",
      name: "device_details",
      Cell: (data) => {
        return (
          <>
            <p>
              <strong> Device Brand : </strong> {data?.device_brand || ""}
            </p>
            <p>
              <strong> Device Type : </strong> {data?.device_type || ""}
            </p>
            <p>
              <strong> OS Name : </strong> {data?.os_name || ""}
            </p>
            <p>
              <strong> OS Version : </strong> {data?.os_version || ""}
            </p>
          </>
        );
      },
    },
    ...(role_manager?.includes("roleManager-list") &&
    role_manager?.includes("update-sub-user")
      ? [
          {
            title: "Approval Status",
            name: "is_approve",
            Cell: (data) => {
              return (
                <div className="button-space d-flex">
                  <ToggleSwitch
                    isLoading={approvedLoader === data?.id}
                    value={data?.is_approve}
                    // disabled={!!approvedLoader || data?.is_approve}
                    onChange={async () => {
                      try {
                        const payload = {
                          id: data?.id,
                          parentId: items?.id,
                          userUuid: data?.user_uuid,
                          isApprove: data?.is_approve === 1 ? 0 : 1,
                        };
                        await updateApprovUser(payload);
                      } catch (err) {
                        console.log("err", err);
                      }
                    }}
                  />
                </div>
              );
            },
          },
        ]
      : []),
    {
      title: "browser id",
      name: "browser_id",
    },
    {
      title: "DATE",
      name: "created_at_ist",
    },
    ...(role_manager?.includes("roleManager-list") &&
    role_manager?.includes("update-sub-user")
      ? [
          {
            title: "ACTIONS",
            name: "actions",
            Cell: (data) => {
              return (
                <Button
                  title="Logout User"
                  color="primary"
                  disabled={!items?.is_logged_in}
                  onClick={() => setDeleteId(data?.id)}
                >
                  <MdLogout />
                </Button>
              );
            },
          },
        ]
      : []),
  ];

  useEffect(() => {
    const newColumns = columns?.map?.((item) => item?.name);
    setFilterColumns(newColumns);
  }, []);

  const onLogout = async () => {
    try {
      setIsLoading(true);
      const payload = {
        id: items?.id,
        loginUserId: deleteId,
      };
      const res = await dispatch(logoutSubUser(payload)).unwrap();
      if (res?.status) {
        onGet();
        setDeleteId("");
      }
      responseToaster(res);
      setIsLoading(false);
    } catch (err) {
      setIsLoading(false);
    }
  };

  return (
    <>
      <Table
        columns={columns}
        filterColumns={filterColumns}
        data={items}
        isData={!!items?.login_users?.length}
        count={items?.login_users?.length || 0}
        isExpandable={false}
        minHeight={200}
      >
        {items?.login_users?.map?.((val) => {
          return (
            <TableRow
              columns={columns}
              filterColumns={filterColumns}
              isExpandable={false}
              item={val}
            />
          );
        })}
      </Table>
      <DeleteModal
        title="Logout this user"
        content="Are you sure you want to log out this user?"
        isOpen={!!deleteId}
        onDoneClick={() => onLogout()}
        onCancelClick={() => setDeleteId("")}
        isButtonLoading={isLoading}
        confirmLabel="Log out"
      />
    </>
  );
};

export default LoginUsers;
